import stockReceive from '@js/store/modules/stock-receive';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('stockReceive', ['hasFinalized']),

        canUpdate() {
            return this.can(this.permission.SAVE_STOCK_RECEIVE);
        },

        canEdit() {
            return this.canUpdate && !this.hasFinalized;
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stockReceive')) {
            this.$store.registerModule('stockReceive', stockReceive);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_receive/stock-receive-mixin.js